import React from "react";
import "./About.scss";
import about_img from "../assets/about_main.png";

const About = () => {
  return (
    <div  className="primary_bg about_cont">
      <div className="container-fluid h-100">
        <div data-aos="fade-up" className="row h-100">
          <div  className="col-12 col-md-6 text-white d-flex justify-content-center align-items-center">
            <img
              className="w-75 w-md-75 about_image"
              src={about_img}
              alt=""
            />
          </div>
          <div
            className="col-12 right_anim col-md-6 about_text  text-white d-flex justify-content-center align-items-center"
          >
            <p className="mt-4 about_para">
              Hello! I am Saif Khan, and I proudly identify myself
              as a software engineer and proficient front-end developer. My
              journey in the captivating realm of web development spans over 3
              years, during which I have honed my coding expertise to a great
              extent. Surprisingly, my background lies in commerce, but I took
              the opportunity to immerse myself in coding during the challenging
              times of the COVID pandemic. Currently, I am pursuing my Masters
              in Computer Application, further enriching my knowledge and skills
              in the tech world. 
              <br /> <br />
              Throughout my career, I have spearheaded and
              actively contributed to an array of projects catering to diverse
              clients, including prominent names like Etihad, WHO, Escorts
              Kubota, Plan India, and AFAQ. A standout experience was the
              privilege of working on-site for a client based in Abu Dhabi,
              where I successfully led and delivered exceptional projects that
              met the client's expectations with utmost finesse.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
